import { companyInfo } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const contactCards = [
  {
    icon: 'ri-phone-line',
    label: '联系电话',
    value: companyInfo.phone,
    href: `tel:${companyInfo.phone}`,
  },
  {
    icon: 'ri-mail-line',
    label: '电子邮箱',
    value: companyInfo.email,
    href: `mailto:${companyInfo.email}`,
  },
  {
    icon: 'ri-time-line',
    label: '工作时间',
    value: companyInfo.workTime,
    href: '',
  },
];

export default function Contact() {
  return (
    <section id="contact" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="reveal">
          <SectionHeading
            eyebrow="Contact Us"
            title="联系我们"
            subtitle="无论是业务咨询、方案需求还是合作意向，欢迎随时与我们沟通，我们会第一时间响应。"
          />
        </div>

        <div className="mt-10 md:mt-14 reveal grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {contactCards.map((card) => {
            const inner = (
              <>
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                  <i className={`${card.icon} text-xl`}></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-foreground-500">{card.label}</span>
                  <span className="block mt-0.5 text-sm text-foreground-900 truncate">{card.value}</span>
                </span>
              </>
            );
            return card.href ? (
              <a
                key={card.label}
                href={card.href}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                {inner}
              </a>
            ) : (
              <div
                key={card.label}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-100 border border-background-200"
              >
                {inner}
              </div>
            );
          })}
        </div>

        <div className="mt-4 md:mt-5 reveal grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <div className="flex items-start gap-4 p-4 rounded-lg bg-background-100 border border-background-200">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
              <i className="ri-map-pin-line text-xl"></i>
            </span>
            <span className="min-w-0">
              <span className="block text-xs text-foreground-500">公司地址</span>
              <span className="block mt-0.5 text-sm text-foreground-900 leading-relaxed">
                {companyInfo.address}
              </span>
            </span>
          </div>

          <div className="flex items-start gap-4 p-4 rounded-lg bg-accent-100/70 border border-accent-200">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-accent-950 shrink-0">
              <i className="ri-customer-service-2-line text-xl"></i>
            </span>
            <span className="min-w-0">
              <span className="block text-xs text-accent-800">即时咨询</span>
              <span className="block mt-0.5 text-sm text-foreground-900 leading-relaxed">
                欢迎直接致电洽谈，我们将安排专属商务为您报价选型。
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}